import { ValueLabel } from "@features/ax/shared/ValueLabel";

const MessageActivityDetailsMessageInfo = ({ data }: { data: any }) => {
   const valueFields = [
          {
            label: "Message Type",
            value: data?.data?.messageInfo?.messageType || "N/A",
          },
          {
            label: "Channel",
            value: data?.data?.messageInfo?.channel || "N/A",
          },
             {
            label: "Status",
            value: data?.data?.messageInfo?.status || "N/A",
          },
          {
            label: "Created by",
            value: data?.data?.messageInfo?.createdBy || "N/A",
          },
          {
            label: "Send on",
            value: data?.data?.messageInfo?.sentOn || "N/A",
          },
          {
            label: "Sent at",
            value: data?.data?.messageInfo?.sentAt || "N/A",
          },
          {
            label: "Recipient list",
            value: "-",
          },
          {
            label: "Total recipients",
            value: "-",
          },
          {
            label: "Trigger",
            value: data?.data?.messageInfo?.trigger || "N/A",
          },
          {
            label: "Workflow name",
            value: data?.data?.messageInfo?.workflowName || "N/A", 
          },
        ];
    return (
      <div className="space-y-6 pl-2 pt-1">
        <h3 className="text-lg font-bold">Message information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {valueFields.map((field, index) => (
            <ValueLabel
              label={field.label}
              value={field.value}
            />
          ))}
        </div>
      </div>
    );
}

export default MessageActivityDetailsMessageInfo